export const chelmsfordFaqs = [
  {
    question: "Are you based in Chelmsford?",
    answer:
      "Yes. Web Wonderland is based in Chelmsford and works as a service-area business. We do not advertise a public office because our registered address is private; project meetings can be held remotely or arranged at a suitable location.",
  },
  {
    question: "What website services do you provide in Chelmsford?",
    answer:
      "We provide website strategy, bespoke web design, WordPress development, WooCommerce, website redesigns, performance improvements, maintenance and ongoing digital support for Chelmsford businesses.",
  },
  {
    question: "Can you improve an existing WordPress website?",
    answer:
      "Yes. We can review an existing WordPress site and improve its structure, design, speed, accessibility, content journey, integrations and ongoing maintenance without assuming that a complete rebuild is always necessary.",
  },
  {
    question: "Can you help a Chelmsford business with local SEO?",
    answer:
      "Yes. We can strengthen the website foundations that support local search, including service-page structure, useful local content, metadata, internal links, technical performance and measurement. Rankings cannot be guaranteed, so improvements are prioritised using search and conversion evidence.",
  },
  {
    question: "Do you only work with businesses in Chelmsford?",
    answer:
      "No. Chelmsford is our home area, but we support organisations across Essex, Greater London and the wider UK. The same experienced team can work remotely or arrange project meetings where useful.",
  },
  {
    question: "How do we start a website project?",
    answer:
      "Tell us what the business needs to achieve, what is not working today and any timing or budget considerations. We will review the requirement, arrange a focused conversation if it looks like a good fit and recommend a practical next step.",
  },
]

export const southendFaqs = [
  {
    question: "Are you based in Southend-on-Sea?",
    answer:
      "No. Web Wonderland is based in Chelmsford and supports Southend-on-Sea as an Essex service-area business. We do not claim a Southend office; meetings can be held remotely or arranged at a suitable location when useful.",
  },
  {
    question: "What website services do you provide for Southend businesses?",
    answer:
      "We provide website strategy, bespoke web design, WordPress development, WooCommerce, booking and enquiry journeys, website redesigns, performance improvements, maintenance and digital marketing support.",
  },
  {
    question: "Can you meet with a Southend-on-Sea business?",
    answer:
      "Yes. Most discovery, planning and review sessions work efficiently online, but an in-person project meeting can be arranged at a suitable Southend or Essex location when it would materially help the work.",
  },
  {
    question: "Can you improve an existing WordPress website?",
    answer:
      "Yes. We can review an existing WordPress site and improve its structure, speed, accessibility, content, integrations, booking or enquiry journey and ongoing maintenance without assuming that a full rebuild is always necessary.",
  },
  {
    question: "Can you help with local SEO in Southend-on-Sea?",
    answer:
      "Yes. We can improve the website foundations that support local discovery, including service-page structure, useful area content, metadata, internal links, technical performance and measurement. Rankings cannot be guaranteed, so priorities are guided by search and conversion evidence.",
  },
  {
    question: "Do you only work with businesses in Southend?",
    answer:
      "No. We support organisations across Essex, Greater London and the wider UK. That includes Southend Central, Leigh-on-Sea, Westcliff-on-Sea, Thorpe Bay, Shoeburyness and surrounding south Essex areas.",
  },
]

export const colchesterFaqs = [
  {
    question: "Are you based in Colchester?",
    answer:
      "No. Web Wonderland is based in Chelmsford and supports Colchester as an Essex service-area business. We do not claim a Colchester office; meetings can be held remotely or arranged at a suitable location when useful.",
  },
  {
    question: "What website services do you provide for Colchester businesses?",
    answer:
      "We provide website strategy, bespoke web design, WordPress and WooCommerce development, integrations, website redesigns, accessibility and performance improvements, maintenance and digital marketing support.",
  },
  {
    question: "Can you support a complex or established WordPress website?",
    answer:
      "Yes. We can work with established WordPress platforms that need custom functionality, API integrations, content restructuring, performance work, WooCommerce improvements or reliable ongoing technical support.",
  },
  {
    question: "Can you meet with a Colchester business?",
    answer:
      "Yes. We normally run focused discovery and review sessions online, with in-person meetings arranged at a suitable Colchester or Essex location where the project benefits from them.",
  },
  {
    question: "Can you help a Colchester business with SEO?",
    answer:
      "Yes. We can connect technical SEO, content structure, local search foundations and measurement to the website. We do not guarantee rankings; recommendations are prioritised around relevant demand, current performance and the quality of enquiries the business needs.",
  },
  {
    question: "Do you only work with businesses in Colchester?",
    answer:
      "No. We work throughout Essex and across the UK. Around Colchester that includes Stanway, Wivenhoe, Marks Tey, Tiptree, West Mersea and surrounding north Essex areas.",
  },
]

const commonResearchItems = [
  {
    label: "Practical website guide",
    text: "Website structure guide for Essex SMEs",
    description:
      "Plan a clearer website structure around customer questions, priority services and useful enquiry journeys.",
    url: "/blog/best-website-structure-essex/",
  },
  {
    label: "Search strategy guide",
    text: "Local SEO and AI search for Essex businesses",
    description:
      "Understand how local visibility, useful content and AI-influenced search discovery now work together.",
    url: "/blog/digital-marketing-essex/",
  },
  {
    label: "Ongoing technical support",
    text: "WordPress support in Essex",
    description:
      "Explore dependable maintenance, performance improvements and practical WordPress advice after launch.",
    url: "/services/maintenance-support/",
  },
]

export const chelmsfordLocationPage = {
  slug: "chelmsford",
  breadcrumbLabel: "Chelmsford",
  h1Text: "Web design & WordPress Chelmsford",
  heroText:
    "Local digital expertise, connected to the results your business needs.",
  heroSubText:
    "Web design, WordPress development and digital marketing from an experienced team based in Chelmsford, Essex.",
  motionHeading: "Chelmsford, connected.",
  contactUrl:
    "/contact-us/?service=new-website&source=web-design-chelmsford",
  split: {
    title: "Web design and WordPress support for Chelmsford businesses.",
    paragraphs: [
      "A business website has to do more than look credible. It needs to make your offer easy to understand, answer the questions customers are already asking and create a clear route to an enquiry, booking or purchase.",
      "Web Wonderland combines website strategy, user experience, content structure, design and development. We can create a new website, improve an underperforming WordPress platform or connect the site more effectively to marketing and business systems.",
      "Being based in Chelmsford gives us useful local context, but the work is defined by your audience and commercial requirement. We support local service businesses, established organisations and teams that operate across Essex and the wider UK.",
    ],
    details: [
      {
        heading: "Based In",
        content:
          "Chelmsford, working as a service-area business without a public office.",
      },
      {
        heading: "Services",
        content:
          "Web design, WordPress, WooCommerce, digital marketing, maintenance and automation.",
      },
      {
        heading: "Meetings",
        content:
          "Remote by default, with in-person project meetings arranged where useful.",
      },
    ],
    buttonText: "Plan Your Project",
  },
  servicesLead: {
    eyebrow: "Connected digital services",
    title: "The right specialist support, joined around one business goal.",
    intro:
      "Start with the problem the business needs to solve. We will help define whether the most useful response is a new website, a focused improvement programme or broader digital support.",
  },
  services: [
    {
      title: "Web design and redesigns",
      paragraphText:
        "Strategy-led websites shaped around the audience, customer journey and commercial result—not a generic template with a town name added.",
      imgFilename: "web-design-new.jpg",
      ctaUrl: "/services/web-design-development/",
      ctaText: "Explore Web Design",
    },
    {
      title: "WordPress development",
      paragraphText:
        "Bespoke WordPress websites, WooCommerce, integrations and improvements that give your team a more useful platform to manage and grow.",
      imgFilename: "wordpress-services.jpg",
      ctaUrl: "/services/wordpress-development-essex/",
      ctaText: "Explore WordPress Development",
    },
    {
      title: "SEO and digital growth",
      paragraphText:
        "Local search foundations, content, campaigns and measurement connected to the website so decisions can be based on meaningful evidence.",
      imgFilename: "marketing-strategy.jpg",
      ctaUrl: "/services/digital-marketing/",
      ctaText: "Explore Digital Marketing",
    },
  ],
  proof: {
    eyebrow: "Evidence behind the service",
    title: "Real projects, different audiences and practical outcomes.",
    intro:
      "These case studies show how clear structure, dependable development and joined-up thinking are applied to different organisations.",
    keys: ["gtsse", "ampersand", "ich"],
  },
  local: {
    eyebrow: "Chelmsford, Essex",
    title: "Based in Chelmsford, serving businesses across Essex.",
    paragraphs: [
      "Web Wonderland is a Chelmsford service-area business. Our registered address is private, so we do not publish it as a place for customer visits or mark it as a public office.",
      "We work remotely with clients and arrange in-person meetings at a suitable location when the project benefits from it.",
    ],
    facts: [
      { term: "Home area", detail: "Chelmsford, Essex" },
      { term: "Coverage", detail: "Essex, Greater London and UK-wide" },
      {
        term: "Contact",
        detail: "01245 806125 or hello@webwonderland.co.uk",
      },
    ],
    map: {
      title: "Map showing the wider Chelmsford area in Essex",
      src: "https://www.openstreetmap.org/export/embed.html?bbox=0.3900%2C51.6900%2C0.5500%2C51.7900&layer=mapnik",
      caption:
        "The map shows the wider Chelmsford service area, not a public office.",
      link: "https://www.openstreetmap.org/#map=11/51.7356/0.4685",
    },
  },
  research: {
    backdrop: "CHELMSFORD",
    eyebrow: "Useful next steps",
    title: "Continue your research.",
    intro:
      "Explore related Essex services and practical guides before deciding what your project needs.",
    items: [
      {
        label: "Local service hub",
        text: "All Essex service areas",
        description:
          "See how our Chelmsford base connects to businesses and organisations across Essex and beyond.",
        url: "/locations/",
      },
      ...commonResearchItems,
    ],
  },
  faqs: chelmsfordFaqs,
  cta: {
    title: "Planning a website or digital project in Chelmsford?",
    text: "Tell us what the business needs to achieve and what is getting in the way. We will help you identify the most useful next step.",
    buttonText: "Discuss Your Project",
    buttonLink:
      "/contact-us/?service=new-website&source=web-design-chelmsford",
  },
}

export const southendLocationPage = {
  slug: "southend-on-sea",
  breadcrumbLabel: "Southend-on-Sea",
  h1Text: "Web design & WordPress Southend-on-Sea",
  heroText:
    "Fast, clear digital experiences for customers ready to enquire, book or buy.",
  heroSubText:
    "Web design, WordPress development and digital marketing for Southend-on-Sea businesses, delivered by an experienced Essex team.",
  motionHeading: "Southend, connected.",
  contactUrl:
    "/contact-us/?service=new-website&source=web-design-southend-on-sea",
  split: {
    title: "Web design and WordPress support for Southend-on-Sea businesses.",
    paragraphs: [
      "When a customer discovers a Southend business through search, maps, social media or a recommendation, the website has to turn that interest into a clear next step. On mobile, slow pages and complicated journeys create friction particularly quickly.",
      "Web Wonderland combines website strategy, content structure, design and technical WordPress development. We can build a new platform, improve an existing site or connect booking, e-commerce, marketing and business systems more effectively.",
      "We support Southend-on-Sea from our Chelmsford base. That gives you an experienced Essex team without a false local-office claim, with remote collaboration and in-person project meetings arranged where they add value.",
    ],
    details: [
      {
        heading: "Working From",
        content:
          "Chelmsford, supporting Southend-on-Sea as an Essex service-area business.",
      },
      {
        heading: "Useful For",
        content:
          "Service businesses, professional teams, visitor-facing organisations, e-commerce and growing SMEs.",
      },
      {
        heading: "Coverage",
        content:
          "Southend Central, Leigh, Westcliff, Thorpe Bay, Shoeburyness and surrounding areas.",
      },
    ],
    buttonText: "Plan Your Southend Project",
  },
  servicesLead: {
    eyebrow: "Southend digital services",
    title: "A stronger route from local discovery to customer action.",
    intro:
      "The most useful solution may be a new website, a focused WordPress improvement programme or better connections between search, campaigns, bookings and enquiries.",
  },
  services: [
    {
      title: "Mobile-first web design and redesigns",
      paragraphText:
        "Clear, responsive websites that help customers understand what you offer and move naturally towards an enquiry, booking, visit or purchase.",
      imgFilename: "web-design-new.jpg",
      ctaUrl: "/services/web-design-development/",
      ctaText: "Explore Web Design",
    },
    {
      title: "WordPress, WooCommerce and booking journeys",
      paragraphText:
        "Bespoke WordPress development, e-commerce, integrations and practical improvements for websites that need to do more than act as an online brochure.",
      imgFilename: "wordpress-services.jpg",
      ctaUrl: "/services/wordpress-development-essex/",
      ctaText: "Explore WordPress Development",
    },
    {
      title: "Local SEO and joined-up campaigns",
      paragraphText:
        "Useful local content, search foundations, campaign landing pages and measurement designed around relevant demand rather than vanity traffic.",
      imgFilename: "marketing-support.jpg",
      ctaUrl: "/services/digital-marketing/",
      ctaText: "Explore Digital Marketing",
    },
  ],
  proof: {
    eyebrow: "Evidence behind the work",
    title: "Customer journeys, dependable platforms and measurable outcomes.",
    intro:
      "These projects show how brand, website, booking, content and campaign decisions can work together around a genuine business requirement.",
    keys: ["homeLegends", "gtsse", "ampersand"],
  },
  local: {
    eyebrow: "Southend-on-Sea, Essex",
    title: "Supporting Southend businesses and the wider south Essex area.",
    paragraphs: [
      "Southend brings together distinct neighbourhoods and business communities, from the city centre and seafront to Leigh, Westcliff, Thorpe Bay and Shoeburyness. A useful website should reflect the people you serve and the action you want them to take.",
      "Web Wonderland is based in Chelmsford rather than Southend. We collaborate remotely and arrange in-person project meetings at a suitable location when the work benefits from them.",
    ],
    facts: [
      { term: "Service area", detail: "Southend-on-Sea and south Essex" },
      {
        term: "Nearby areas",
        detail: "Leigh, Westcliff, Thorpe Bay, Shoeburyness, Rochford and Rayleigh",
      },
      {
        term: "Contact",
        detail: "01245 806125 or hello@webwonderland.co.uk",
      },
    ],
    map: {
      title: "Map showing the wider Southend-on-Sea area in Essex",
      src: "https://www.openstreetmap.org/export/embed.html?bbox=0.6000%2C51.5000%2C0.8200%2C51.6200&layer=mapnik",
      caption:
        "The map shows the wider Southend-on-Sea service area, not a public office.",
      link: "https://www.openstreetmap.org/#map=11/51.5459/0.7077",
    },
  },
  research: {
    backdrop: "SOUTHEND",
    eyebrow: "Useful next steps",
    title: "Continue your Southend research.",
    intro:
      "Explore practical Essex guides and connected services before deciding what your website or marketing project needs.",
    items: [
      {
        label: "Local service hub",
        text: "All Essex service areas",
        description:
          "Compare our Southend-on-Sea, Chelmsford and Colchester service information in one place.",
        url: "/locations/",
      },
      ...commonResearchItems,
    ],
  },
  faqs: southendFaqs,
  cta: {
    title: "Planning a website or digital project in Southend-on-Sea?",
    text: "Tell us what customers need to do, where the existing journey breaks down and what success should look like. We will recommend a practical next step.",
    buttonText: "Discuss Your Southend Project",
    buttonLink:
      "/contact-us/?service=new-website&source=web-design-southend-on-sea",
  },
}

export const colchesterLocationPage = {
  slug: "colchester",
  breadcrumbLabel: "Colchester",
  h1Text: "Web design & WordPress Colchester",
  heroText:
    "Clearer websites and stronger digital foundations for ambitious organisations.",
  heroSubText:
    "Web design, WordPress development and digital marketing for Colchester businesses, delivered by an experienced Essex team.",
  motionHeading: "Colchester, connected.",
  contactUrl:
    "/contact-us/?service=new-website&source=web-design-colchester",
  split: {
    title: "Web design and WordPress support for Colchester businesses.",
    paragraphs: [
      "An established organisation often needs more than an attractive brochure website. Services must be easy to navigate, content needs clear ownership and the platform has to support campaigns, integrations and future change without becoming fragile.",
      "Web Wonderland brings website strategy, user experience, content structure, design and technical WordPress development together. We can create a new platform, improve an existing site or solve a focused performance, integration or conversion problem.",
      "We support Colchester from our Chelmsford base, working remotely with local teams and arranging in-person project meetings where useful. The scope is shaped around your customers and commercial needs rather than a generic location-page package.",
    ],
    details: [
      {
        heading: "Working From",
        content:
          "Chelmsford, supporting Colchester as an Essex service-area business.",
      },
      {
        heading: "Useful For",
        content:
          "Professional services, established organisations, e-commerce, charities and growing SMEs.",
      },
      {
        heading: "Coverage",
        content:
          "Colchester, Stanway, Wivenhoe, Marks Tey, Tiptree, West Mersea and north Essex.",
      },
    ],
    buttonText: "Plan Your Colchester Project",
  },
  servicesLead: {
    eyebrow: "Colchester digital services",
    title: "Strategy, content and development working as one system.",
    intro:
      "Start with the organisational or customer problem. We will help define whether the right response is a new platform, targeted improvements or a joined-up programme of digital work.",
  },
  services: [
    {
      title: "Web design for established and growing businesses",
      paragraphText:
        "Strategy-led websites that clarify complex services, build trust and give different audiences a more direct path to the information or action they need.",
      imgFilename: "web-design-new.jpg",
      ctaUrl: "/services/web-design-development/",
      ctaText: "Explore Web Design",
    },
    {
      title: "WordPress development and integrations",
      paragraphText:
        "Bespoke WordPress, WooCommerce, APIs and platform improvements that give internal teams a dependable website they can manage and extend.",
      imgFilename: "wordpress-services.jpg",
      ctaUrl: "/services/wordpress-development-essex/",
      ctaText: "Explore WordPress Development",
    },
    {
      title: "SEO, content and digital growth",
      paragraphText:
        "Search foundations, useful content, campaign journeys and measurement connected to the same audience and commercial priorities.",
      imgFilename: "marketing-strategy.jpg",
      ctaUrl: "/services/digital-marketing/",
      ctaText: "Explore Digital Marketing",
    },
  ],
  proof: {
    eyebrow: "Evidence behind the work",
    title: "Complex requirements made clearer, faster and easier to use.",
    intro:
      "These projects show how robust development, accessible journeys and structured content support very different organisations and audiences.",
    keys: ["gtsse", "ampersand", "ich"],
  },
  local: {
    eyebrow: "Colchester, Essex",
    title: "Supporting Colchester businesses and organisations across north Essex.",
    paragraphs: [
      "Colchester supports a broad mix of established organisations, professional teams, independents and growing businesses across the city and surrounding communities. Their websites often need to serve local audiences while supporting a much wider market.",
      "Web Wonderland is based in Chelmsford rather than Colchester. We work remotely with teams and arrange in-person project meetings at a suitable location when they add value.",
    ],
    facts: [
      { term: "Service area", detail: "Colchester and north Essex" },
      {
        term: "Nearby areas",
        detail: "Stanway, Wivenhoe, Marks Tey, Tiptree, West Mersea and Witham",
      },
      {
        term: "Contact",
        detail: "01245 806125 or hello@webwonderland.co.uk",
      },
    ],
    map: {
      title: "Map showing the wider Colchester area in Essex",
      src: "https://www.openstreetmap.org/export/embed.html?bbox=0.8200%2C51.8200%2C1.0800%2C51.9600&layer=mapnik",
      caption:
        "The map shows the wider Colchester service area, not a public office.",
      link: "https://www.openstreetmap.org/#map=11/51.8959/0.8919",
    },
  },
  research: {
    backdrop: "COLCHESTER",
    eyebrow: "Useful next steps",
    title: "Continue your Colchester research.",
    intro:
      "Explore practical Essex guides and connected services before deciding what your platform or marketing project needs.",
    items: [
      {
        label: "Local service hub",
        text: "All Essex service areas",
        description:
          "Compare our Colchester, Chelmsford and Southend-on-Sea service information in one place.",
        url: "/locations/",
      },
      ...commonResearchItems,
    ],
  },
  faqs: colchesterFaqs,
  cta: {
    title: "Planning a website or digital project in Colchester?",
    text: "Tell us what the organisation needs to achieve, what is difficult to manage today and where customers are getting stuck. We will recommend a practical next step.",
    buttonText: "Discuss Your Colchester Project",
    buttonLink:
      "/contact-us/?service=new-website&source=web-design-colchester",
  },
}
